// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__InW33","col":"styles_col__2bZz-"};